import tokens from "../design-system/tokens";
import useMedia from "../hooks/useMedia.js";

export function isMobileDevice() {
  //covers iPadOS with desktop UA
  const uaMobile =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  const touchCapable =
    typeof navigator !== "undefined" && navigator.maxTouchPoints > 0;
  return uaMobile || touchCapable;
}

export function useIsWindowSmall() {
  return useMedia(tokens.mediaQuery.sm);
}
